import script from "./LibraryHome20321.vue?vue&type=script&setup=true&lang=ts"
export * from "./LibraryHome20321.vue?vue&type=script&setup=true&lang=ts"

import "./LibraryHome20321.vue?vue&type=style&index=0&id=3a0faf8b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0faf8b"]])

export default __exports__